const responseBodyAsJson = (response) =>
  response.status === 204
    ? null
    : response.json().then((result) => {
        if (!response.ok) {
          const err = new Error(result.message || response.statusText);
          err.status = response.status;
          if (response.status === 500) {
            err.message =
              "Oops, something went wrong on the server. Please try again later.";
          }
          throw err;
        }
        return result;
      });

export const createApi = (baseUrl) => {
  const commonHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json;charset=UTF-8",
  };

  /* Array ( Request -> Response -> Promise Response ) */
  const responseHandlers = [];

  const setHeaders = (headers) => Object.assign(commonHeaders, headers);

  const request = (path, options) => {
    const requestUrl = `${baseUrl}${path}`;
    const requestOptions = {
      method: "GET",
      ...options,
      headers: {
        ...commonHeaders,
        ...options.headers,
      },
    };
    return responseHandlers
      .reduce(
        (responsePromise, handler) =>
          responsePromise.then((response) =>
            handler(new Request(requestUrl, requestOptions))(response),
          ),
        fetch(new Request(requestUrl, requestOptions)),
      )
      .catch((err) => {
        throw new Error("Oops, something went wrong. Please try again later.");
      })
      .then(responseBodyAsJson);
  };

  const createRequestType = (type) => (path, options) =>
    request(path, { ...options, method: type });

  const deleteRequest = createRequestType("DELETE");
  const get = createRequestType("GET");
  const post = createRequestType("POST");
  const put = createRequestType("PUT");

  /* useResponse :: (Request -> Response -> Promise Response) -> (() -> ()) */
  const useResponse = (handler) => {
    responseHandlers.push(handler);
    return () => {
      const handlerAt = responseHandlers.indexOf(handler);
      if (handlerAt !== -1) {
        responseHandlers.splice(handlerAt, 1);
      }
    };
  };

  return { delete: deleteRequest, get, post, put, setHeaders, useResponse };
};

export const save =
  (api) =>
  (path) =>
  ({ id, ...otherProps }) => {
    const httpMethod = id ? api.put : api.post;
    return httpMethod(id ? `${path}/${id}` : path, {
      body: JSON.stringify(otherProps),
      credentials: "include",
    });
  };

export const toUrlSearchParams = (params) => {
  const qsParams = new URLSearchParams();
  Object.keys(params).forEach((k) => {
    const value = params[k];
    if (Array.isArray(value)) {
      value.forEach((v) => qsParams.append(k, v));
    } else {
      qsParams.append(k, value);
    }
  });
  return qsParams;
};
